export const ASC = 'ASC';
export const DESC = 'DESC';



// WEBPACK FOOTER //
// ./src/show-page/constants/launch-date-order.js